export { default } from "bullitttime-embercomponents/components/event-dashboard";
